// =============================================================
// OZ WASTE CO. — REVIEW DATA (manually editable)
// -------------------------------------------------------------
// This is the ONLY file you need to edit to change the reviews
// section on the homepage. Nothing here is fetched from an API.
// =============================================================

export interface Review {
  /** Customer name shown under the review. EDIT HERE. */
  name: string;
  /** Relative time posted, e.g. "1 year ago", "3 months ago". EDIT HERE. */
  date: string;
  /** Star rating out of 5 (whole numbers). EDIT HERE. */
  rating: number;
  /** Full review text. Long text auto-collapses with a "Read more" button. EDIT HERE. */
  text: string;
  /** Optional customer profile image URL. Leave "" to show a circular initial avatar. EDIT HERE. */
  image?: string;
  /** Optional direct link to the review on Google. Leave "" to hide the link. EDIT HERE. */
  googleUrl?: string;
}

// -------------------------------------------------------------
// OVERALL RATING + TOTAL REVIEW COUNT (shown in the summary row)
// EDIT HERE.
// -------------------------------------------------------------
export const googleReviewSummary = {
  rating: 5.0,
  reviewCount: 27,
};

// -------------------------------------------------------------
// GOOGLE BUSINESS PROFILE URL
// Single source of truth for the Google Business Profile link used
// across the site (hero trust badge + footer Google Maps icon).
// EDIT HERE to update every reference at once.
// -------------------------------------------------------------
export const googleBusinessUrl = "https://maps.app.goo.gl/cmVjAMDB96gwQHwV9";

// -------------------------------------------------------------
// REVIEW LIST
// Carousel works well with roughly 6 to 20 entries.
// Replace each entry below with a genuine Google review:
//   name      -> reviewer name
//   date      -> relative date Google shows
//   rating    -> stars given
//   text      -> exact review text
//   image     -> reviewer avatar URL (optional)
//   googleUrl -> permalink to the review (optional)
// -------------------------------------------------------------
export const reviews: Review[] = [
  {
    name: "Ahmad Salman",
    date: "Edited 17 hours ago",
    rating: 5,
    text: "The movers were really helpful. I loved the way they kept all my belongings safe and nothing was missing or broken.",
    image: "",
    googleUrl: "",
  },
  {
    name: "kevin akoch",
    date: "a day ago",
    rating: 5,
    text: "The movers were awesome and were very careful with my belongings. Would highly recommend",
    image: "",
    googleUrl: "",
  },
  {
    name: "Ali Halwani",
    date: "a day ago",
    rating: 5,
    text: "I’ve had a lot of movers in the past. These are the best guys by far. There worked really hard and the move was really professional and productive",
    image: "",
    googleUrl: "",
  },
  {
    name: "Allerton Linne",
    date: "2 days ago",
    rating: 5,
    text: "Highly recommend Oz Waste Co. Great communication, fair pricing, and the team did an excellent job. Easily one of the best moving companies I’ve dealt with",
    image: "",
    googleUrl: "",
  },
  {
    name: "Nina Kynando",
    date: "5 days ago",
    rating: 5,
    text: "Used them for my office relocation and it was seamless. Everything was packed securely, nothing got damaged, and they worked efficiently without rushing or cutting corners. The whole team was polite, easy to talk to, and kept me updated throughout the whole process. Way better than the other companies I’ve used before, worth every dollar!",
    image: "",
    googleUrl: "",
  },
  {
    name: "morina nanomi",
    date: "6 days ago",
    rating: 5,
    text: "We had a full house to move and I was worried about how the day would go, but the team was fantastic. They were careful, efficient, and really easy to talk to. I’d happily recommend them to anyone",
    image: "",
    googleUrl: "",
  },
  {
    name: "ibrahim salman",
    date: "a week ago",
    rating: 5,
    text: "The movers were brilliant, really happy with the service and my move into my new home. Would definitely reach out to you guys again",
    image: "",
    googleUrl: "",
  },
  {
    name: "Viraj sarao",
    date: "a week ago",
    rating: 5,
    text: "The boys from Oz move Co were really awesome. All my belongings were packed safely and not one of my things got damaged. If you’re going to hire movers these are the guys to contact 💯",
    image: "",
    googleUrl: "",
  },
  {
    name: "Abdulrahman Azougga",
    date: "a week ago",
    rating: 5,
    text: "The guys were friendly, efficient, and looked after all our stuff, the whole move was done quicker than I expected, thanks again",
    image: "",
    googleUrl: "",
  },
  {
    name: "Adam",
    date: "a week ago",
    rating: 5,
    text: "Really impressed with Oz Waste Co. The guys were on time, careful with our furniture, and made the whole move easy. Would definitely recommend.",
    image: "",
    googleUrl: "",
  },
];
